<template>
	<div v-loading="src && loading && !isLocal" class="pxlt-iframe">
		<no-content v-if="isLocal || failedToLoad" />
		<iframe
			v-else
			v-show="showIframe"
			:ref="iframeRef"
			:src="src"
			@error="onError"
			@load="onLoad"
		/>
	</div>
</template>

<script>
import { uniqueKey } from '~/assets/util/helpers'
import { NoContent } from '~/components/particles'

export default {
	name: 'TheIframe',
	components: { NoContent },
	props: {
		src: {
			type: String,
			required: false,
			default: null
		}
	},
	data () {
		return {
			loading: true,
			showIframe: false,
			failedToLoad: false,
			isLocal: process.env.LOCAL_ENV,
			iframeRef: uniqueKey()
		}
	},
	computed: {
		iframe () {
			return this.$refs[this.iframeRef]
		},
		document () {
			return this.iframe && this.iframe.contentDocument
		},
		head () {
			return this.document && this.document.head
		},
		body () {
			return this.document && this.document.body
		}
	},
	methods: {
		onError () {
			this.showIframe = false
			this.loading = false
			this.failedToLoad = true

			this.$bugsnag.notify(new Error('[IFrame] Failed to load iframe content'))
		},
		onLoad (event) {
			const hasBodyContent = this.body && this.body.innerHTML

			if (hasBodyContent) {
				this.onSuccessLoad(event)
			} else {
				this.onError()
			}
		},
		onSuccessLoad (event) {
			this.appendCustomStyles()
			this.deleteExternalChatBot()
			this.updateIframeHeight()
			this.adjustContentStyles()
			this.addEventListeners()

			this.showIframe = true // successfully render iframe after styles append;
			this.$emit('onLoad', event)
			setTimeout(this.updateIframeHeight, 1500)
			setTimeout(() => {
				if (parseInt(this.iframe.style.height, 10) < 20) {
					this.onError()
				} else {
					this.loading = false
				}
			}, 1600)
		},
		deleteExternalChatBot () {
			const chatBot = this.document.getElementById('zsiq_float')

			chatBot && chatBot.remove()
		},
		appendCustomStyles () {
			const customStyles = document.createElement('link')

			customStyles.type = 'text/css'
			customStyles.rel = 'stylesheet'
			customStyles.href = '/my/custom-iframe-styles.css'

			this.head.appendChild(customStyles)
		},
		updateIframeHeight () {
			this.iframe.style.height = `${this.document && this.document.documentElement.offsetHeight}px`
		},
		adjustContentStyles () {
			const styles = 'height:fit-content;overflow:hidden;'

			this.document.documentElement.style.cssText = styles
			this.body.style.cssText = styles
		},
		addEventListeners () {
			window.addEventListener('resize', this.updateIframeHeight)
			this.document.documentElement.addEventListener('click', this.updateIframeHeight)
		}
	}
}
</script>

<style lang="scss">
	.pxlt-iframe {
		min-height: 700px;

		iframe {
			border: none;
			width: 100%;
		}
	}

	@include respond-between(laptop, desktop) {
		.zoom-in iframe {
			zoom: 1.35;
		}
	}
</style>
